import { render, staticRenderFns } from "./priceSyncRulesModal.vue?vue&type=template&id=acc2dba2&scoped=true"
import script from "./priceSyncRulesModal.vue?vue&type=script&lang=js"
export * from "./priceSyncRulesModal.vue?vue&type=script&lang=js"
import style0 from "./priceSyncRulesModal.vue?vue&type=style&index=0&id=acc2dba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc2dba2",
  null
  
)

export default component.exports